<main class="error-container">
  <div class="article__intro container container--large js-waypoints-trigger-initial anim-appear">
    <div class="article__intro-text">
      <h1 style="color: #3B4B5C;">Title</h1>
      <h2 style="color: #3B4B5C;">
        error.page.content
      </h2>
      <ng-container *ngFor="let item of constants.HTTP_ERRORS">
        <div *ngIf="error.status === item.id.toString()">{{ 'error.description' | translate | async }}: {{ error.status }} - {{ item.i18nkey | translate | async}}</div>
      </ng-container>
    </div>
  </div>
</main>
